import React from 'react'
import Button from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import Box from '@material-ui/core/Box'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import { standardTubeRoute, useRouter } from '@src/routes'
import {
  ActiveLinkType,
  TubeProperties,
  TubeProduct,
} from '../../../utils/StandardMTOEnum'
import { configContext } from '../../../utils/StandardReducer'
import { ConfiguratorProductDetails } from '../../ConfiguratorSharedTypes'

interface AddOligoProps {
  productDetails: ConfiguratorProductDetails
  updateError: any
  errorMessage: string
}
const useStyles = makeStyles((theme: Theme) => ({
  box: {
    borderStyle: 'dashed',
    borderColor: theme.palette.grey[900],
    borderWidth: 1,
    marginTop: theme.spacing(5),
  },
  button: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.primary.main,
    margin: theme.spacing(6),
  },
  icon: {
    color: theme.palette.primary.main,
  },
}))

const AddOligo: React.FC<AddOligoProps> = (props) => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(configContext)
  const { oligoCount, sessionData, countryCode } = state
  const { productDetails, updateError, errorMessage } = props
  const router = useRouter()
  const intl = useIntl()
  const maxItems =
    productDetails.productType === TubeProduct.iscaledna
      ? TubeProperties.MaximumOligosAllowedIscaledna
      : TubeProperties.MaximumOligosAllowed
  const sequencePath = `${standardTubeRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.SequenceEntry}`

  const setInitialState = () => {
    if (sessionData.length !== 0 && sessionData[0].applyToAll) {
      return {
        additionalCarrierProtein: sessionData[0].additionalCarrierProtein,
        additionalComments: '',
        additionalServices: sessionData[0].additionalServices,
        amount: sessionData[0].amount,
        applyToAll: false,
        autoValidation: '',
        baseCount: 0,
        carrierProtein: '',
        cartId: '',
        comments: '',
        concentration: sessionData[0].concentration,
        conjugation: sessionData[0].conjugation,
        conjugationAmount: sessionData[0].conjugationAmount,
        conjugationChemistry: sessionData[0].conjugationChemistry,
        countryCode: countryCode,
        crossContamination: '',
        crRnaType: '',
        cterminalMod: '',
        currency: '',
        currencySymbol: '',
        customPeptideType: '',
        epsilon: 0,
        fiveMod: '',
        fiveModCategory: '',
        flag: sessionData[0].flag,
        format: sessionData[0].format,
        fullSOligoBackbone: false,
        gcContent: '',
        id: (state.oligoCount + 1).toString(),
        internalModCategory: '',
        isLabelledAminoAcid: true,
        isoCode: false,
        isOverridden: false,
        itemId: '',
        listError: [
          {
            key: '',
            value: '',
          },
        ],
        material: '',
        meltingTemparature: '',
        minimumYield: '',
        molecularWeight: '',
        name: '',
        nterminalMod: '',
        oligoId: state.oligoCount + 1,
        orderItemId: '',
        otherValue: '',
        packageType: '',
        plateType: '',
        price: '',
        primerDimer: '',
        productType: productDetails.productType,
        purification: sessionData[0].purification,
        purityLevel: sessionData[0].purityLevel,
        quantitation: '',
        scale: sessionData[0].scale,
        secondaryStructure: '',
        sequence: '',
        sequenceLocation: '',
        threeMod: '',
        threeModCategory: '',
        tubes: sessionData[0].tubes,
      }
    }
    return {
      additionalCarrierProtein: 'None',
      additionalComments: '',
      additionalServices: [],
      amount: '',
      applyToAll: false,
      autoValidation: '',
      baseCount: 0,
      carrierProtein: '',
      cartId: '',
      comments: '',
      concentration: '',
      conjugation: 'None',
      conjugationAmount: '',
      conjugationChemistry: '',
      countryCode: countryCode,
      crossContamination: '',
      crRnaType: '',
      cterminalMod: '',
      currency: '',
      currencySymbol: '',
      customPeptideType: '',
      epsilon: 0,
      fiveMod: '',
      fiveModCategory: '',
      flag: 0,
      format: 'DRY',
      fullSOligoBackbone: false,
      gcContent: '',
      id: (state.oligoCount + 1).toString(),
      internalModCategory: '',
      isLabelledAminoAcid: true,
      isoCode: false,
      isOverridden: false,
      itemId: '',
      listError: [
        {
          key: '',
          value: '',
        },
      ],
      material: '',
      meltingTemparature: '',
      minimumYield: '',
      molecularWeight: '',
      name: '',
      nterminalMod: '',
      oligoId: state.oligoCount + 1,
      orderItemId: '',
      otherValue: '',
      packageType: '',
      plateType: '',
      price: '',
      primerDimer: '',
      productType: productDetails.productType,
      purification: '',
      purityLevel: '',
      quantitation: '',
      scale: '',
      secondaryStructure: '',
      sequence: '',
      sequenceLocation: '',
      threeMod: '',
      threeModCategory: '',
      tubes: '1',
    }
  }
  React.useEffect(() => {
    if (state.isAddOligoFromConfirmPage) {
      const newIndex = sessionData.length
      dispatch({
        type: 'UPDATE_OLIGO_INDEX',
        data: newIndex,
      })
      dispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: newIndex,
      })
      state.sessionData.push(setInitialState())

      dispatch({ type: 'IS_TUBE_PAGE_LOAD', data: false })
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...state.errorData,
          name: '',
          sequence: '',
          scale: '',
          purification: '',
          fiveMod: '',
          threeMod: '',
          researcher: '',
          format: 'DRY',
          concentration: '',
          tubes: '1',
          countryCode: countryCode,
          fullSOligoBackbone: false,
          isOverridden: false,
          comments: '',
          cterminalMod: '',
          nterminalMod: '',
          otherValue: '',
          isLabelledAminoAcid: true,
          quantitation: '',
          purityLevel: '',
          amount: '',
          conjugation: 'None',
          conjugationAmount: '',
          conjugationChemistry: '',
          additionalCarrierProtein: 'None',
          additionalServices: [],
          flag: 0,
        },
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({ type: 'IS_ADD_OLIGO_FROM_CONFIRM_PAGE', data: false })
    }
  }, [state.oligoCount])
  const addProductFromConfirm = () => {
    if (errorMessage !== undefined && errorMessage !== '') {
      updateError(errorMessage)
    } else {
      if (
        sessionData.length <
        (productDetails.productType === TubeProduct.iscaledna
          ? TubeProperties.MaximumOligosAllowedIscaledna
          : TubeProperties.MaximumOligosAllowed)
      ) {
        router.push(sequencePath)
        dispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: false })
        dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
        dispatch({ type: 'IS_LABEL_AMINO_ACID_ERROR', data: false })
        dispatch({ type: 'ADD_NEW_OLIGO', data: oligoCount + 1 })
        dispatch({ type: 'IS_ADD_OLIGO_FROM_CONFIRM_PAGE', data: true })
      } else {
        updateError(
          intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems })
        )
      }
    }
    window.scrollTo(0, 0)
  }

  return (
    <Box
      mb={4}
      display="flex"
      justifyContent="center"
      borderRadius="borderRadius"
      className={classes.box}
    >
      <Button
        onClick={addProductFromConfirm}
        size="medium"
        className={classes.button}
        startIcon={<AddCircleIcon fontSize="small" className={classes.icon} />}
      >
        <FormattedMessage
          {...messages[`CONF_ADD_OLIGO_SIDE_BAR_${productDetails.productType}`]}
        />
      </Button>
    </Box>
  )
}
export default AddOligo
